import React from 'react';
import {  TextField, MenuItem, FormControlLabel, Checkbox, FormGroup } from '@mui/material';
import { BlockTypes, BlockFormState, ItemState } from '../../types';
import SelectList from '../../../../../Components/Elements/SelectList';
import DossierQuerySelect from '../../../../../Components/Elements/Select/DossierQuerySelect';

interface GeneralTabProps {
    kedo: any;
    state: BlockFormState;
    handleChange: (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void;
    handleChangeItem: (key: keyof ItemState, val: any) => void;
    fetchCustomViews: () => void;
    fetchQueries: () => void;
    isEntityRequired: boolean;
}

const GeneralTab: React.FC<GeneralTabProps> = ({
    kedo,
    state,
    handleChange,
    handleChangeItem,
    fetchCustomViews,
    fetchQueries,
    isEntityRequired,
}) => {
    return (
        <>
            <TextField
                select
                required
                size="small"
                fullWidth
                label={kedo.t('Block Type')}
                name="type"
                value={state.item.type || ''}
                onChange={handleChange}
                error={!!(state.errors && state.errors.type)}
                helperText={state.errors && state.errors.type}
                margin="normal"
            >
                <MenuItem value="">{kedo.t('Choose an option')}</MenuItem>
                {Object.entries(BlockTypes).map(([key, value]) => (
                    <MenuItem key={value} value={value}>
                        {kedo.t(key)}
                    </MenuItem>
                ))}
            </TextField>

            {isEntityRequired && (
                <TextField
                    select
                    required
                    size="small"
                    fullWidth
                    label={kedo.t('Entity')}
                    name="defDossier"
                    value={state.item.defDossier || ''}
                    onChange={(e) => {
                        handleChange(e);
                        fetchCustomViews();
                        fetchQueries();
                    }}
                    error={!!(state.errors && state.errors.defDossier)}
                    helperText={state.errors && state.errors.defDossier}
                    margin="normal"
                >
                    <MenuItem value="">{kedo.t('Choose an option')}</MenuItem>
                    {state.defDossiers.map((defDossier: any) => (
                        <MenuItem key={defDossier.id} value={defDossier.id}>
                            {kedo.env().translateItem(defDossier, 'defdossier')}
                        </MenuItem>
                    ))}
                </TextField>
            )}

            <FormControlLabel
                control={
                    <Checkbox
                        name="dashboard"
                        checked={state.item.dashboard}
                        onChange={handleChange}
                        disabled={state.loading}
                    />
                }
                label={kedo.t('Dashboard')}
                sx={{ mt: 1, mb: 2 }}
            />

            <FormGroup>
                <SelectList
                    currentValue={state.item.parent_id}
                    onClear={() => handleChangeItem('parent_id', null)}
                    searchName={'search'}
                    kedo={kedo}
                    urlParams={{
                        page: 0,
                        limit: 200,
                        type: 'block_container',
                        environment: kedo.env().getEnvironment().id,
                    }}
                    onDisplayName={(item: any) =>
                        kedo.env().translateItem(item, 'mypageblock')
                    }
                    url={kedo.api().getMyPageBlockEndpoint()}
                    onSelect={(item: any) => handleChangeItem('parent_id', item.id)}
                />
            </FormGroup>

            <FormGroup>
                <DossierQuerySelect
                    kedo={kedo}
                    onChange={(newId: any) => handleChangeItem('dossierQuery', newId)}
                    value={state.item.dossierQuery}
                    ddId={state.item.defDossier}
                />
            </FormGroup>
        </>
    );
};

export default GeneralTab;